var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "#278351",
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 23.75C21.6284 23.75 23.7342 21.6283 23.7342 19L23.7501 9.5C23.7501 6.87167 21.6284 4.75 19.0001 4.75C16.3717 4.75 14.2501 6.87167 14.2501 9.5V19C14.2501 21.6283 16.3717 23.75 19.0001 23.75ZM27.3917 19C27.3917 23.75 23.3701 27.075 19.0001 27.075C14.6301 27.075 10.6084 23.75 10.6084 19H7.91675C7.91675 24.415 12.2234 28.8642 17.4167 29.64V34.8333H20.5834V29.64C25.7767 28.88 30.0834 24.415 30.0834 19H27.3917Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioChat);
export default __webpack_public_path__ + "static/media/audioChat.90240e52.svg";
export { ForwardRef as ReactComponent };